import React from "react";
import WebinarsGrid from "../components/WebinarsGrid";
import PageWrapper from "../components/PageWrapper";
import HeroSection from "../components/Headers";
import Seo from "../components/Seo";

const scrollToWebinarSection = () => {
    if (typeof window === 'undefined') return;
    const target = sessionStorage.getItem('holborn:webinarScrollTarget');
    if (target) {
        sessionStorage.removeItem('holborn:webinarScrollTarget');
        setTimeout(() => {
            const el = document.getElementById(target);
            if (el) {
                el.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        }, 100);
    }
};

const WebinarsPage = () => {
    React.useEffect(() => {
        scrollToWebinarSection();
    }, []);
    return (
        <PageWrapper
            pageTitle="Webinars"
            pageDescription="Secure your place for Holborn’s upcoming webinars and events, where our experts delve into a range of financial topics or view our on-demand content."
        >
            <HeroSection
                title="Webinars"
                subtitle2="Industry experts host our webinars and provide insights into key financial topics. Book a spot on upcoming webinars or go back and listen to previous ones."
            />
            <WebinarsGrid />
        </PageWrapper>
    );
};

export const Head = ({ location }) => {
    return (
        <Seo
            title="Webinars"
            description="Secure your place for Holborn’s upcoming webinars and events, where our experts delve into a range of financial topics or view our on-demand content."
            canonical={location.pathname}
        />
    );
};

export default WebinarsPage;